module.exports = __webpack_public_path__ + "assets/img/hp.e5449df2.png";